// Basemap from Landmælingar Íslands (now part of Náttúrufræðistofnun) via
// their open WMS, a standard map API that returns an image per map tile. The
// request carries an SLD style, so the IS 50V coastline and roads come back
// in this map's own palette.
export const LMI_WMS_URL = "https://gis.lmi.is/geoserver/wms";

export const LMI_ATTRIBUTION =
  'Map data &copy; <a href="https://www.natt.is">Náttúrufræðistofnun</a> (Landmælingar Íslands, IS 50V)';

// Mirrors the colour tokens in AqMap.css; WMS tiles cannot read CSS variables.
const PALETTE = {
  light: {
    land: "#eef0e8",
    coast: "#3b4a50",
    echo: "#b7c8ce",
    road: "#bcc5c8",
  },
  dark: {
    land: "#212c2f",
    coast: "#8ea3a9",
    echo: "#1b282c",
    road: "#38474a",
  },
};

// Coastal echo lines, widest first, like depth contours on a nautical chart
const ECHOES = [16, 8];

// Streets only appear from roughly zoom 12, close enough to tell them apart;
// further out they merge into grey blobs.
const ROADS_MAX_SCALE = 150000;

const LAND = "IS_50V:strandlina_flakar";
const ROADS = "IS_50V:samgongur_linur";

const stroke = (color, width, opacity = 1) =>
  `<Stroke><CssParameter name="stroke">${color}</CssParameter><CssParameter name="stroke-width">${width}</CssParameter><CssParameter name="stroke-opacity">${opacity}</CssParameter><CssParameter name="stroke-linejoin">round</CssParameter></Stroke>`;

const rule = (symbolizer, maxScale) =>
  `<FeatureTypeStyle><Rule>${
    maxScale ? `<MaxScaleDenominator>${maxScale}</MaxScaleDenominator>` : ""
  }${symbolizer}</Rule></FeatureTypeStyle>`;

const namedLayer = (name, rules) =>
  `<NamedLayer><Name>${name}</Name><UserStyle>${rules.join("")}</UserStyle></NamedLayer>`;

// Land with echo bands and coastline, then roads, in one image per tile
export const baseParams = (theme) => {
  const c = PALETTE[theme];
  const land = namedLayer(LAND, [
    ...ECHOES.map((width) =>
      rule(`<LineSymbolizer>${stroke(c.echo, width, 0.5)}</LineSymbolizer>`),
    ),
    rule(
      `<PolygonSymbolizer><Fill><CssParameter name="fill">${c.land}</CssParameter></Fill>${stroke(c.coast, 1.25)}</PolygonSymbolizer>`,
    ),
  ]);
  const roads = namedLayer(ROADS, [
    rule(
      `<LineSymbolizer>${stroke(c.road, 0.8)}</LineSymbolizer>`,
      ROADS_MAX_SCALE,
    ),
  ]);

  return {
    layers: `${LAND},${ROADS}`,
    styles: "",
    format: "image/png",
    transparent: true,
    sld_body: `<StyledLayerDescriptor version="1.0.0" xmlns="http://www.opengis.net/sld" xmlns:ogc="http://www.opengis.net/ogc">${land}${roads}</StyledLayerDescriptor>`,
  };
};
